import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets window scroll to (0, 0) whenever the route pathname changes.
 *
 * If the URL contains a hash (e.g. /#pricing), instead of scrolling to top
 * we scroll to that element after a short delay (so lazy-loaded sections
 * have time to mount). Falls back to top if the element isn't found.
 *
 * Mount once inside the <BrowserRouter>.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Try a few times — sections rendered after route mount may not be in
      // the DOM on the first tick.
      const id = hash.replace('#', '');
      let attempts = 0;
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
          return;
        }
        attempts += 1;
        if (attempts < 10) setTimeout(tryScroll, 80);
        else window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      };
      tryScroll();
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
